export const scrollTop = () => {
  const appElement = document.querySelector(".App");

  appElement?.scrollTo(0, 0);
};
